module.exports = __webpack_public_path__ + "static/img/4.4432f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/4.png
// module id = xU8L
// module chunks = 1